import React, { Component } from "react";
import {
  Router,
  Route,
  browserHistory,
  Redirect,
  IndexRoute,
} from "react-router";
import ReactGA from "react-ga4";
import IdleTimer from "react-idle-timer";
import { setLanguage } from "react-multi-lang";
import { Logout, getMenudata } from "./actions/accountAction";
import { checkJobseekerConsent } from "./actions/jobseekerAction";
import {
  getConsentCheckResult,
  getConsentPagePath,
  isConsentAllowedPath,
  isJobseekerLoggedIn,
} from "./consentUtils";
import store from "./store";

import Home from "./components/Home";
import Signup from "./components/signup/Signup";
import feedbackForm from "./components/signup/feedbackForm";
import RegistrationForm from "./components/signup/RegistrationForm";
import SignIn from "./components/login/SignIn";
import Resetpass from "./components/login/Resetpass";
import VerifyUser from "./components/login/VerifyUser";

import AdvanceSearch from "./components/AdvanceSearch";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import LocalServicePage from "./components/LocalServicePage";
import JobFairEmployers from "./components/dashboard/JobFairEmployers";
import JobSeekersPage from "./components/JobSeekersPage";
import GuestPage from "./components/GuestPage";
import EmployerPage from "./components/EmployerPage";
import ForeignEmployementPage from "./components/ForeignEmployementPage";
import ChangePassword from "./components/dashboard/ChangePassword";
import CopyRight from "./components/dashboard/CopyRight";
import Privacy from "./components/dashboard/Privacy";
import Faq from "./components/dashboard/Faq";
import NoticeForFraud from "./components/dashboard/NoticeForFraud";
// import MobilizationDrive from './components/dashboard/MobilizationDrive'
import ForeignStudyCamp from "./components/dashboard/ForeignStudyCamp";
import RateEnquiry from "./components/dashboard/RateEnquiry";
// import ForgeinJobs from './components/dashboard/ForgeinJobs'
import SelfEmpSectors from "./components/CareerOpportunities";

import GovtJobs from "./components/dashboard/GovtJobs";
import Services from "./components/dashboard/Services";
import Employment from "./components/dashboard/Employment";
import Help from "./components/dashboard/Help";
import Sitemap from "./components/dashboard/Sitemap";
import SelfEmployment from "./components/dashboard/SelfEmployment";
// import Labour from './components/dashboard/Labour'
import ForeignInfo from "./components/dashboard/ForeignModuleInfo";

import Webinar from "./components/dashboard/Webinar";
import Downloads from "./components/dashboard/Downloads";
import FreeTraining from "./components/FreeTraining";
import CounsellingSessions from "./components/dashboard/CounsellingSessions";

import CounsellingProviderAccount from "./components/dashboard/counsellingprovider/MyAccount";
import CounsellingProviderProfile from "./components/dashboard/counsellingprovider/MyProfile";
import PostCounselling from "./components/dashboard/counsellingprovider/PostCounselling";
import SessionCalendar from "./components/dashboard/counsellingprovider/SessionCalendar";
import AppliedCandidates from "./components/dashboard/counsellingprovider/AppliedCandidates";
import SessionFeedback from "./components/dashboard/counsellingprovider/SessionFeedback";

import PrivateJobs from "./components/dashboard/PrivateJobs";
import UserManual from "./components/dashboard/UserManual";
import HowToUse from "./components/dashboard/jobseeker/HowToUse";
import ApplyWebinar from "./components/dashboard/jobseeker/ApplyWebinar";
import Forum from "./components/dashboard/jobseeker/Forum";
import AppliedJobFair from "./components/dashboard/jobseeker/AppliedJobFair";
import HallTicket from "./components/dashboard/jobseeker/HallTicket";
import SearchCareer from "./components/dashboard/jobseeker/SearchCareer";
import ForeignCounsellingDetails from "./components/dashboard/jobseeker/ForeignCounsellingDetails";
// import HowToUseProvider from './components/dashboard/jobprovider/HowToUseProvider'
import PortalFeedback from "./components/dashboard/PortalFeedback";
import MobileSignIn from "./components/login/MobileSignIn";
import JobDetailPage from "./components/dashboard/JobDetailPage";
import ScreenRecorder from "./components/dashboard/ScreenRecorder";
import JobDetailHomePage from "./components/JobDetailHomePage";
import NCSJobDetail from "./components/NCSJobDetail";
import SearchResults from "./components/dashboard/SearchResults";
import SearchResultsDemo from "./components/dashboard/SearchResultsDemo";
import SearchNcsJob from "./components/dashboard/SearchNcsJob";

import Jobsearch from "./components/dashboard/jobseeker/Jobsearch";
import AllInvites from "./components/dashboard/AllInvites";
import AllJobsForUser from "./components/dashboard/jobseeker/AllJobsForUser";
import MyAccount from "./components/dashboard/jobseeker/MyAccount";
import Myprofile from "./components/dashboard/jobseeker/Myprofile";
import ConsentPage from "./components/dashboard/jobseeker/ConsentPage";
import SearchSelfEmployment from "./components/dashboard/jobseeker/SearchSelfEmployment";
import AppliedJobs from "./components/dashboard/jobseeker/AppliedJobs";
import Interest from "./components/dashboard/jobseeker/Interest";

import SkillProgram from "./components/dashboard/jobseeker/SkillProgram";
import SearchSession from "./components/dashboard/jobseeker/SearchSession";
import SearchSessionByArea from "./components/dashboard/jobseeker/SearchSessionByArea";
import CounsellingDetails from "./components/dashboard/jobseeker/CounsellingDetails";
import JobproviderApplyJob from "./components/dashboard/jobprovider/ApplyJob";
import PostJob from "./components/dashboard/jobprovider/PostJob";
import Providerprofile from "./components/dashboard/jobprovider/Providerprofile";
// import SchduledInterviews from './components/dashboard/jobprovider/SchduledInterviews';
// import Servicesearch from './components/dashboard/jobseeker/Servicesearch';
// import AppliedJobsProvider from './components/dashboard/jobprovider/AppliedJobsProvider';
import CandidatesList from "./components/dashboard/jobprovider/CandidatesList";
import SelectedCandidatesList from "./components/dashboard/jobprovider/SelectedCandidatesList";
import ConfirmedCandidates from "./components/dashboard/jobprovider/ConfirmedCandidates";
// import Search from './components/dashboard/jobprovider/Search';
import auth from "./components/hoc/auth";
// import checkForeignStudyProvider from './components/hoc/checkForeignStudyProvider'
import checkCounsellor from "./components/hoc/checkCounsellor";
import checkActiveJobMela from "./components/hoc/checkActiveJobMela";
import notAuth from "./components/hoc/notAuth";
import PageNotFound from "./components/dashboard/PageNotFound";
import AccessDenied from "./components/dashboard/AccessDenied";

// import CreateEvent from './components/dashboard/CreateEvent'
// import Events from './components/dashboard/Events'

import ContactUs from "./components/ContactUs";
// import Videos from "./components/Videos";
import Notification from "./components/Notification";

// import ImageGallery from "./components/ImageGallery";
import Crm from "./components/dashboard/jobseeker/Crm";

import Lspaccount from "./components/dashboard/localserviceprovider/LspServices";
import Lspprofile from "./components/dashboard/localserviceprovider/Providerprofile";
import VisitCalendar from "./components/dashboard/localserviceprovider/VisitCalendar";
import ServiceFeedback from "./components/dashboard/localserviceprovider/ServiceFeedback";
import AppliedServiceCandidates from "./components/dashboard/localserviceprovider/AppliedCandidates";
import LspPostJob from "./components/dashboard/localserviceprovider/PostServices";

import aboutus from "./components/aboutus";
import SkilldevelopmentRti from "./components/skilldevelopmentRti";
import SkilldevelopmentScheme from "./components/skilldevelopmentScheme";
import SkilldevelopmentAchievement from "./components/skilldevelopmentAchievement";
import OngoingSkillCourses from "./components/ongoingSkillCourses";

import skilldevelopmentAchievement from "./components/skilldevelopmentAchievement";
import skilldevelopmentScheme from "./components/skilldevelopmentScheme";
import skilldevelopmentRti from "./components/skilldevelopmentRti";
import skilldevelopmentContact from "./components/skilldevelopmentContact";
import skilldevelopmentEnplanement from "./components/skilldevelopmentEnplanement";
import ongoingSkillCourses from "./components/ongoingSkillCourses";
import schemesList from "./components/dashboard/schemesList";
import schemedescription from "./components/dashboard/shemedescription";

import SearchSkillResult from "./components/dashboard/SearchSkillResult";
import HireMee from "./components/dashboard/jobseeker/HireMee";
import uniceff from "./components/dashboard/uniceff";
import jobMela from "./components/dashboard/jobseeker/jobMela";
import HallTicketList from "./components/dashboard/jobseeker/HallTicketList";
import JobResume from "./components/dashboard/jobseeker/JobResume";
import RegistrationIDCard from "./components/dashboard/jobseeker/RegistrationIDCard";
import SkillDevelopement from "./components/dashboard/jobseeker/SkillDevelopement";
import UnderMaintainance from "./components/UnderMaintainance";
import SearchSkillTraining from "./components/dashboard/jobseeker/SearchSkillTraining";

import DemoWidget from "./components/demoWidget";
import WebPolicy from "./components/WebPolicy";
import HelpSupport from "./components/dashboard/jobseeker/Help&Support";
import VerifyAdhar from "./components/dashboard/jobseeker/VerifyAdhar";
import AuthenticationFailure from "./components/dashboard/jobseeker/AuthenticationFailure";
import AuthenticationSuccess from "./components/dashboard/jobseeker/AuthenticationSuccess";
import PrintDemo from "./components/dashboard/jobseeker/PrintDemo";
import PmVikasScheme from "./components/dashboard/PmVikasScheme";
import SearchPmScheme from "./components/dashboard/jobseeker/SearchPmScheme";
import PmOtpVerification from "./components/dashboard/jobseeker/PmOtpVerification";
import ArchivalPolicy from "./components/ArchivalPolicy";
import ArchivalTenders from "./components/ArchivalTenders";
import VerifyProfile from "./components/dashboard/VerifyProfile";
// import PmOtpVerification from './components/dashboard/jobseeker/PmOtpVerification';

// Forgien job provider
// import ForgienJobproviderAccount from './components/dashboard/forgienjobprovider/ForgienJobproviderAccount'
// import PostForgienJob from './components/dashboard/forgienjobprovider/PostForgienJob'
// import ForgienProviderTimeline from './components/dashboard/forgienjobprovider/ForgienProviderTimeline'
// import ForgienProviderprofile from './components/dashboard/forgienjobprovider/ForgienProviderprofile'
// import ForeignCandidatesList from './components/dashboard/forgienjobprovider/CandidatesList';
// import SelectedForeignCandidatesList from './components/dashboard/forgienjobprovider/SelectedCandidatesList';
// import ConfirmedForeignCandidates from './components/dashboard/forgienjobprovider/ConfirmedCandidates';
// import SearchForgienJob from './components/dashboard/jobseeker/SearchForgienJob'
// import checkForeignJobProvider from './components/hoc/checkForeignJobProvider'

// import ForgienStudyAccount from './components/dashboard/forgienstudyprovider/MyAccount'
// import AppliedEventCandidates from './components/dashboard/forgienstudyprovider/AppliedEventCandidates'
// import ForgienStudyProviderprofile from './components/dashboard/forgienstudyprovider/MyProfile'
// import PostStudy from './components/dashboard/forgienstudyprovider/PostStudy'
// import AppliedCourseCandidates from './components/dashboard/forgienstudyprovider/AppliedCandidates'
// import ShortlistedCourseCandidates from './components/dashboard/forgienstudyprovider/ShorlistedCandidates'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTimedOut: false,
    };
    this.idleTimer = React.createRef();
  }

  /**
   * Extract language from URL and initialize it
   */
  initializeLanguageFromUrl = () => {
    const pathname = this.props.location.pathname;
    const pathParts = pathname.split('/').filter(part => part);
    const validLanguages = ['hi', 'pa'];

    // Check if lang param exists in route params (for /:lang routes)
    const langParam = this.props.params && this.props.params.lang;

    let lang = 'en'; // Default to English
    if (langParam && validLanguages.includes(langParam)) {
      lang = langParam;
    } else if (pathParts.length > 0 && validLanguages.includes(pathParts[0])) {
      lang = pathParts[0];
    }

    // Validate language - if invalid language code, redirect to English version
    // Only strip when there is a path after the fake lang (e.g. /xyz/about → /about).
    // Do not treat single segments like /signup as lang=signup and redirect to home.
    if (langParam && !validLanguages.includes(langParam)) {
      if (pathParts.length > 1) {
        const pathWithoutLang = '/' + pathParts.slice(1).join('/');
        browserHistory.replace(pathWithoutLang || '/');
      }
      lang = 'en';
    }

    // Set language in localStorage and react-multi-lang
    localStorage.setItem('language', lang);
    document.documentElement.lang = lang;
    setLanguage(lang);
    store.dispatch(getMenudata());

    return lang;
  }

  /**
   * Check if current route needs language prefix and redirect if needed
   */
  checkAndRedirectLanguage = () => {
    const pathname = this.props.location.pathname;
    const pathParts = pathname.split('/').filter(part => part);
    const validLanguages = ['hi', 'pa'];

    // Check if current path already has a language prefix
    const hasLanguagePrefix = pathParts.length > 0 && validLanguages.includes(pathParts[0]);

    // Get the selected language from localStorage
    const selectedLang = localStorage.getItem('language');

    // If user has selected a language (other than English) and current path doesn't have language prefix
    // Redirect to language-prefixed version
    if (selectedLang && selectedLang !== 'en' && validLanguages.includes(selectedLang) && !hasLanguagePrefix) {
      // Build new path with language prefix (preserve query string e.g. ?type=1 on signup)
      const search = this.props.location.search || '';
      const newPath = (pathname === '/' ? `/${selectedLang}` : `/${selectedLang}${pathname}`) + search;
      browserHistory.replace(newPath);
      return true; // Indicates redirect happened
    }

    return false; // No redirect needed
  }

  componentDidMount() {
    // First validate language if we're on a /:lang route
    const langParam = this.props.params && this.props.params.lang;
    const validLanguages = ['hi', 'pa'];

    // If lang param exists but is invalid, redirect to English version
    // Only when a real path follows the invalid prefix (avoid /signup → home)
    if (langParam && !validLanguages.includes(langParam)) {
      const pathname = this.props.location.pathname;
      const pathParts = pathname.split('/').filter(part => part);
      if (pathParts.length > 1) {
        const pathWithoutLang = '/' + pathParts.slice(1).join('/');
        browserHistory.replace(pathWithoutLang || '/');
      }
      return;
    }

    const redirected = this.checkAndRedirectLanguage();
    if (!redirected) {
      this.initializeLanguageFromUrl();
    }

    this.enforceJobseekerConsentGate();

    // Re-check when Loginuser hydrates after Islogin
    this._unsubscribeConsent = store.subscribe(() => {
      if (!isJobseekerLoggedIn() || this._consentGateResolved) return;
      const loginuser = store.getState().actionReducer.Loginuser;
      const userId =
        loginuser && typeof loginuser === "object" && !Array.isArray(loginuser)
          ? loginuser.id || loginuser.user_id
          : null;
      if (userId) {
        this.enforceJobseekerConsentGate();
      }
    });
  }

  componentWillUnmount() {
    if (this._unsubscribeConsent) {
      this._unsubscribeConsent();
    }
  }

  /**
   * If a jobseeker has consent: 0, lock them to /consent-page only.
   * Blocks /jobsearch, /change-password, /myprofile, home, etc.
   */
  enforceJobseekerConsentGate = async () => {
    if (!isJobseekerLoggedIn()) return;

    const pathname =
      (this.props.location && this.props.location.pathname) ||
      window.location.pathname ||
      "";

    if (isConsentAllowedPath(pathname)) {
      this._consentGateResolved = true;
      return;
    }

    if (getConsentCheckResult() === "0") {
      this._consentGateResolved = true;
      browserHistory.replace(getConsentPagePath(pathname));
      return;
    }

    if (this._consentGateInFlight) return;
    this._consentGateInFlight = true;

    try {
      const loginuser = store.getState().actionReducer.Loginuser;
      const userId =
        loginuser && typeof loginuser === "object" && !Array.isArray(loginuser)
          ? loginuser.id || loginuser.user_id
          : null;

      if (!userId) {
        // Loginuser not hydrated yet — use cached result if present
        if (getConsentCheckResult() === "0") {
          this._consentGateResolved = true;
          browserHistory.replace(getConsentPagePath(pathname));
        }
        return;
      }

      const hasConsent = await store.dispatch(checkJobseekerConsent(userId));
      this._consentGateResolved = true;
      if (!hasConsent) {
        browserHistory.replace(getConsentPagePath(pathname));
      }
    } finally {
      this._consentGateInFlight = false;
    }
  };

  _onAction = (e) => {
    this.setState({ isTimedOut: false });
  };

  _onIdle = (e) => {
    const { isTimedOut } = this.state;
    if (
      isTimedOut &&
      localStorage.getItem("token") &&
      localStorage.getItem("token") !== "null"
    ) {
      store.dispatch(Logout());
    } else {
      this.idleTimer.current.reset();
      this.setState({ isTimedOut: true });
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
      this._consentGateResolved = false;

      // First validate language if we're on a /:lang route
      const langParam = this.props.params && this.props.params.lang;
      const validLanguages = ['hi', 'pa'];

      // If lang param exists but is invalid, redirect to English version
      if (langParam && !validLanguages.includes(langParam)) {
        const pathname = this.props.location.pathname;
        const pathParts = pathname.split('/').filter(part => part);
        // Only strip invalid lang when a path follows it (avoid /signup → home)
        if (pathParts.length > 1) {
          const pathWithoutLang = '/' + pathParts.slice(1).join('/');
          browserHistory.replace(pathWithoutLang || '/');
        }
        return;
      }

      // Check if redirect is needed first
      const redirected = this.checkAndRedirectLanguage();
      if (!redirected) {
        // Re-initialize language when route changes
        this.initializeLanguageFromUrl();
      }

      this.enforceJobseekerConsentGate();
    }
  }

  render() {
    return (
      <div id="rootContent">
        <IdleTimer
          key="idleTimer"
          ref={this.idleTimer}
          element={document}
          // onActive={this._onActive}
          onIdle={this._onIdle}
          timeout={1000 * 60 * 10} //10 minutes
        />
        <Header route={this.props.location} router={this.props.router} />
        <div className="education-main-section education-letest-newsfull logoimg wow ext-mrg-pd main-content-height px-0">
          <div className="container-fluid top-m px-0">
            {this.props.children}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

// ✅ Initialize Google Analytics
ReactGA.initialize("G-TNRFDW4DB9"); // Replace with your GA4 Measurement ID

// ✅ Track page views on route change
browserHistory.listen((location) => {
  // ReactGA.send({ hitType: 'pageview', page: location.pathname });
  ReactGA.send({
    hitType: "pageview",
    page: window.location.href, // send only the path
  });
});

const router = (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={Home} />
      <Route path="/notification" component={Notification} />
      {/* <Route path="videos" component={Videos} /> */}
      <Route path="downloads" component={Downloads} />
      {/* <Route path="gallery" component={ImageGallery} /> */}
      <Route path="signup" component={notAuth(Signup)} />
      <Route path="feedback-form" component={feedbackForm} />
      <Route path="registration-form" component={RegistrationForm} />
      <Route path="/local-services" component={Services} />
      <Route path="signin" component={SignIn} />
      <Route path="resetpassword" component={notAuth(Resetpass)} />
      <Route path="/about" component={JobSeekersPage} />
      <Route path="/guestpage" component={GuestPage} />
      <Route path="/services" component={EmployerPage} />
      <Route
        path="/foreignemployementpage"
        component={ForeignEmployementPage}
      />
      <Route path="/industrylist" component={LocalServicePage} />
      <Route path="/change-password" component={ChangePassword} />
      <Route path="/portal-feedback" component={PortalFeedback} />
      <Route path="/signin-with-otp" component={notAuth(MobileSignIn)} />
      <Route path="/advance-search" component={AdvanceSearch} />
      <Route path="/govt-jobs" component={GovtJobs} />
      <Route path="/private-jobs" component={PrivateJobs} />
      <Route path="/search-results" component={SearchResults} />
      <Route path="/search-results-demo" component={SearchResultsDemo} />
      {/* <Route path='/search-ncs-jobs' component={SearchNcsJob} /> */}
      <Route path="/outsource-jobs" component={SearchNcsJob} />

      <Route path="/job-details-home/:jobId" component={JobDetailHomePage} />
      <Route path="/ncs-job-details" component={NCSJobDetail} />
      <Route path="/contact-us" component={ContactUs} />
      <Route path="/copyright-policy" component={CopyRight} />
      <Route path="/privacy-policy" component={Privacy} />
      <Route path="/faq" component={Faq} />
      <Route path="/fraudulent-cases" component={NoticeForFraud} />
      {/* <Route path='/mobilization-drive' component={MobilizationDrive} /> */}
      <Route path="/foreign-study-campaign" component={ForeignStudyCamp} />
      <Route path="/rate-enquiry/:id" component={RateEnquiry} />
      <Route path="/employment" component={Employment} />
      <Route path="/help" component={Help} />
      <Route path="/uniceff" component={uniceff} />
      <Route path="/sitemap" component={Sitemap} />
      <Route path="/verify-user" component={VerifyUser} />
      <Route path="/screen-reader" component={ScreenRecorder} />
      <Route path="/user-manual" component={UserManual} />
      {/* <Route path='/foreign-jobs' component={ForgeinJobs} /> */}
      <Route path="/career-opportunities" component={SelfEmpSectors} />
      <Route path="/self-employment" component={SelfEmployment} />
      <Route path="/pm-vikas-scheme" component={PmVikasScheme} />
      <Route path="/counselling-sessions" component={CounsellingSessions} />
      <Route path="/foreign-module-info" component={ForeignInfo} />
      <Route path="/webinar" component={Webinar} />
      <Route path="/forum" component={Forum} />
      <Route path="/invites" component={AllInvites} />
      <Route path="/free-training" component={FreeTraining} />
      <Route
        path="/job-placement-fair-employers/:id"
        component={JobFairEmployers}
      />
      <Route path="/aboutus" component={aboutus} />
      {/* Shared route for verify-profile - accessible to all authenticated users */}
      <Route path="/verify-profile" component={auth(VerifyProfile)} />
      {/* 
            <Route path='/skilldevelopment-rti' component={SkilldevelopmentRti} />
            <Route path='/schemes-list' component={SkilldevelopmentScheme} />
            <Route path='/skilldevelopment-achievement' component={SkilldevelopmentAchievement} />

            <Route path='/OngoingSkillCourses' component={OngoingSkillCourses} /> */}

      <Route
        path="/skilldevelopment-achievement"
        component={skilldevelopmentAchievement}
      />
      <Route
        path="/skilldevelopment-scheme"
        component={skilldevelopmentScheme}
      />
      <Route path="/skilldevelopment-rti" component={skilldevelopmentRti} />
      <Route path="/hq-district-offices" component={skilldevelopmentContact} />
      <Route
        path="/skilldevelopment-enplanement"
        component={skilldevelopmentEnplanement}
      />
      <Route path="/ongoing-skill-courses" component={ongoingSkillCourses} />
      <Route path="/schemes-list" component={schemesList} />
      <Route path="/schemesdescription" component={schemedescription} />
      <Route path="/search-skill-result" component={SearchSkillResult} />
      <Route path="/demo-widget" component={DemoWidget} />
      <Route path="/pm-otp-vertification" component={PmOtpVerification} />
      {/* Shared route for verify-profile - accessible to all authenticated users */}
      <Route path="/verify-profile" component={auth(VerifyProfile)} />

      {localStorage.getItem("login_type") === "Jobseeker" && (
        <Route path="/">
          <Route path="/myaccount" component={auth(MyAccount)} />
          <Route path="/consent-form" component={auth(ConsentPage)} />
          <Route path="/consent-page" component={auth(ConsentPage)} />
          <Route
            path="/registration-id-card"
            component={auth(RegistrationIDCard)}
          />
          <Route path="/verify-profile" component={auth(VerifyProfile)} />
          <Route path="/job-resume" component={auth(JobResume)} />
          <Route path="/job-resume" component={auth(JobResume)} />
          <Route path="/crm" component={auth(Crm)} />
          <Route path="/jobsearch" component={auth(Jobsearch)} />
          <Route path="/apply-webinar" component={auth(ApplyWebinar)} />
          <Route path="/jobs" component={auth(AllJobsForUser)} />
          <Route path="/myprofile" component={auth(Myprofile)} />
          <Route path="/applied/jobs" component={auth(AppliedJobs)} />
          <Route path="/how-to-use" component={auth(HowToUse)} />
          <Route path="/job-details/:jobId" component={auth(JobDetailPage)} />
          <Route path="/interest" component={auth(Interest)} />
          <Route path="/job-mela" component={auth(jobMela)} />
          <Route path="/help-and-support" component={auth(HelpSupport)} />
          <Route
            path="/authentication-failure"
            component={auth(AuthenticationFailure)}
          />
          <Route
            path="/authentication-success"
            component={auth(AuthenticationSuccess)}
          />
          <Route path="/verify-adhar" component={auth(VerifyAdhar)} />
          <Route
            path="/skill-development-courses"
            component={auth(SkillDevelopement)}
          />
          <Route
            path="/counselling-details/:id"
            component={auth(CounsellingDetails)}
          />
          <Route path="/psdm-skill-program" component={auth(SkillProgram)} />
          <Route
            path="/jobfair"
            component={auth(checkActiveJobMela(AppliedJobFair))}
          />
          <Route
            path="/hall-ticket"
            component={auth(checkActiveJobMela(HallTicketList))}
          />
          <Route
            path="/hall-ticket/:id"
            component={auth(checkActiveJobMela(HallTicket))}
          />
          <Route
            path="/search-counselling-session"
            component={auth(SearchSession)}
          />
          {/* <Route path='/forgien-jobs' component={auth(SearchForgienJob)} /> */}
          <Route path="/search-career" component={auth(SearchCareer)} />
          <Route
            path="/search-self-employment"
            component={auth(SearchSelfEmployment)}
          />
          {/* <Route path="/search-pm-scheme" component={auth(SearchPmScheme)} /> */}
          <Route
            path="/search-counselling-session-by-area"
            component={auth(SearchSessionByArea)}
          />
          <Route
            path="/foreign-counselling-details"
            component={auth(ForeignCounsellingDetails)}
          />
          <Route path="/hireMee" component={auth(HireMee)} />
          {/* <Route path='/print-demo' component={auth(PrintDemo)} /> */}
        </Route>
      )}
      {localStorage.getItem("login_type") === "Indian Employer" && (
        <Route path="/">
          <Route path="/myaccount" component={auth(JobproviderApplyJob)} />
          <Route path="/post-job" component={auth(PostJob)} />
          <Route path="/myprofile" component={auth(Providerprofile)} />
          <Route path="/verify-profile" component={auth(VerifyProfile)} />
          <Route
            path="/applied-candidates/:job_id"
            component={auth(CandidatesList)}
          />
          <Route
            path="/shortlisted-candidates/:job_id"
            component={auth(SelectedCandidatesList)}
          />
          <Route
            path="/selected-candidates/:job_id"
            component={auth(ConfirmedCandidates)}
          />
        </Route>
      )}
      {localStorage.getItem("login_type") === "Counselling Provider" && (
        <Route path="/">
          <Route
            path="/myaccount"
            component={auth(checkCounsellor(CounsellingProviderAccount))}
          />
          <Route
            path="/myprofile"
            component={auth(CounsellingProviderProfile)}
          />
          <Route
            path="/post-counselling"
            component={auth(checkCounsellor(PostCounselling))}
          />
          <Route path="/session-feedback" component={auth(SessionFeedback)} />
          <Route path="/session-calendar" component={auth(SessionCalendar)} />
          <Route
            path="/applied-candidates/:id"
            component={auth(checkCounsellor(AppliedCandidates))}
          />
        </Route>
      )}

      {/* {localStorage.getItem('login_type') === 'Local Service Provider' &&
                <Route path='/'>
                    <Route path='/myaccount' component={auth(Lspaccount)} />
                    <Route path='/post-service' component={auth(LspPostJob)} />
                    <Route path='/myprofile' component={auth(Lspprofile)} />
                    <Route path='/visit-calendar' component={auth(VisitCalendar)} />
                    <Route path='/service-feedback' component={auth(ServiceFeedback)} />
                    <Route path='/applied-candidates/:id' component={auth(AppliedServiceCandidates)} />
                </Route>
            } */}

      {/*
            {localStorage.getItem('login_type') === 'Foreign job Provider' &&
                <Route path='/'>
                    <Route path='/myaccount' component={auth(checkForeignJobProvider(ForgienJobproviderAccount))} />
                    <Route path='/post-job' component={auth(checkForeignJobProvider(PostForgienJob))} />
                    <Route path='/myprofile' component={auth(ForgienProviderprofile)} />
                    <Route path='/timeline' component={auth(ForgienProviderTimeline)} />
                    <Route path='/applied-candidates/:job_id' component={auth(ForeignCandidatesList)} />
                    <Route path='/shortlisted-candidates/:job_id' component={auth(SelectedForeignCandidatesList)} />
                    <Route path='/selected-candidates/:job_id' component={auth(ConfirmedForeignCandidates)} />

                </Route>
            } */}
      {/* {localStorage.getItem('login_type') === 'Foreign Study Provider' &&
                <Route path='/'>
                    <Route path='/applied-candidates/:id' component={auth(checkForeignStudyProvider(AppliedCourseCandidates))} />
                    <Route path='/shorlisted-candidates/:id' component={auth(checkForeignStudyProvider(ShortlistedCourseCandidates))} />
                    <Route path='/myaccount' component={auth(checkForeignStudyProvider(ForgienStudyAccount))} />
                    <Route path='/myprofile' component={auth(ForgienStudyProviderprofile)} />
                    <Route path='/post-study' component={auth(checkForeignStudyProvider(PostStudy))} />
                    <Route path='/create-event' component={auth(checkForeignStudyProvider(CreateEvent))} />
                    <Route path='/events' component={auth(checkForeignStudyProvider(Events))} />
                    <Route path='/event-candidates/:id' component={auth(checkForeignStudyProvider(AppliedEventCandidates))} />
                </Route>
            } */}
      <Route path="/404" component={PageNotFound} />
      <Route path="/web-under-maintainance" component={UnderMaintainance} />
      <Route path="/access-denied" component={AccessDenied} />
      <Route path="/website-policy" component={WebPolicy} />
      <Route path="/archival" component={ArchivalPolicy} />
      <Route path="/archived-tenders" component={ArchivalTenders} />
      {/* <Route path='/xyz' component={SearchSkillTraining} /> */}
    </Route>

    {/* Dynamic language-prefixed routes (hi, pa) */}
    <Route path="/:lang" component={App}>
      <IndexRoute component={Home} />
      <Route path="/:lang/notification" component={Notification} />
      <Route path="/:lang/downloads" component={Downloads} />
      <Route path="/:lang/signup" component={notAuth(Signup)} />
      <Route path="/:lang/feedback-form" component={feedbackForm} />
      <Route path="/:lang/registration-form" component={RegistrationForm} />
      <Route path="/:lang/local-services" component={Services} />
      <Route path="/:lang/signin" component={SignIn} />
      <Route path="/:lang/resetpassword" component={notAuth(Resetpass)} />
      <Route path="/:lang/about" component={JobSeekersPage} />
      <Route path="/:lang/guestpage" component={GuestPage} />
      <Route path="/:lang/services" component={EmployerPage} />
      <Route path="/:lang/foreignemployementpage" component={ForeignEmployementPage} />
      <Route path="/:lang/industrylist" component={LocalServicePage} />
      <Route path="/:lang/change-password" component={ChangePassword} />
      <Route path="/:lang/portal-feedback" component={PortalFeedback} />
      <Route path="/:lang/signin-with-otp" component={notAuth(MobileSignIn)} />
      <Route path="/:lang/advance-search" component={AdvanceSearch} />
      <Route path="/:lang/govt-jobs" component={GovtJobs} />
      <Route path="/:lang/private-jobs" component={PrivateJobs} />
      <Route path="/:lang/search-results" component={SearchResults} />
      <Route path="/:lang/search-results-demo" component={SearchResultsDemo} />
      <Route path="/:lang/outsource-jobs" component={SearchNcsJob} />
      <Route path="/:lang/job-details-home/:jobId" component={JobDetailHomePage} />
      <Route path="/:lang/ncs-job-details" component={NCSJobDetail} />
      <Route path="/:lang/contact-us" component={ContactUs} />
      <Route path="/:lang/copyright-policy" component={CopyRight} />
      <Route path="/:lang/privacy-policy" component={Privacy} />
      <Route path="/:lang/faq" component={Faq} />
      <Route path="/:lang/fraudulent-cases" component={NoticeForFraud} />
      <Route path="/:lang/foreign-study-campaign" component={ForeignStudyCamp} />
      <Route path="/:lang/rate-enquiry/:id" component={RateEnquiry} />
      <Route path="/:lang/employment" component={Employment} />
      <Route path="/:lang/help" component={Help} />
      <Route path="/:lang/uniceff" component={uniceff} />
      <Route path="/:lang/sitemap" component={Sitemap} />
      <Route path="/:lang/verify-user" component={VerifyUser} />
      <Route path="/:lang/screen-reader" component={ScreenRecorder} />
      <Route path="/:lang/user-manual" component={UserManual} />
      <Route path="/:lang/career-opportunities" component={SelfEmpSectors} />
      <Route path="/:lang/self-employment" component={SelfEmployment} />
      <Route path="/:lang/pm-vikas-scheme" component={PmVikasScheme} />
      <Route path="/:lang/counselling-sessions" component={CounsellingSessions} />
      <Route path="/:lang/foreign-module-info" component={ForeignInfo} />
      <Route path="/:lang/webinar" component={Webinar} />
      <Route path="/:lang/forum" component={Forum} />
      <Route path="/:lang/invites" component={AllInvites} />
      <Route path="/:lang/free-training" component={FreeTraining} />
      <Route path="/:lang/job-placement-fair-employers/:id" component={JobFairEmployers} />
      <Route path="/:lang/aboutus" component={aboutus} />
      <Route path="/:lang/skilldevelopment-achievement" component={skilldevelopmentAchievement} />
      <Route path="/:lang/skilldevelopment-scheme" component={skilldevelopmentScheme} />
      <Route path="/:lang/skilldevelopment-rti" component={skilldevelopmentRti} />
      <Route path="/:lang/hq-district-offices" component={skilldevelopmentContact} />
      <Route path="/:lang/skilldevelopment-enplanement" component={skilldevelopmentEnplanement} />
      <Route path="/:lang/ongoing-skill-courses" component={ongoingSkillCourses} />
      <Route path="/:lang/schemes-list" component={schemesList} />
      <Route path="/:lang/schemesdescription" component={schemedescription} />
      <Route path="/:lang/search-skill-result" component={SearchSkillResult} />
      <Route path="/:lang/demo-widget" component={DemoWidget} />
      <Route path="/:lang/pm-otp-vertification" component={PmOtpVerification} />
      <Route path="/:lang/404" component={PageNotFound} />
      <Route path="/:lang/web-under-maintainance" component={UnderMaintainance} />
      <Route path="/:lang/access-denied" component={AccessDenied} />
      <Route path="/:lang/website-policy" component={WebPolicy} />
      <Route path="/:lang/archival" component={ArchivalPolicy} />
      <Route path="/:lang/archived-tenders" component={ArchivalTenders} />
      {/* Shared route for verify-profile with language prefix - accessible to all authenticated users */}
      <Route path="/:lang/verify-profile" component={auth(VerifyProfile)} />

      {localStorage.getItem("login_type") === "Jobseeker" && (
        <Route path="/:lang">
          <Route path="/:lang/myaccount" component={auth(MyAccount)} />
          <Route path="/:lang/consent-form" component={auth(ConsentPage)} />
          <Route path="/:lang/consent-page" component={auth(ConsentPage)} />
          <Route path="/:lang/registration-id-card" component={auth(RegistrationIDCard)} />
          <Route path="/:lang/verify-profile" component={auth(VerifyProfile)} />
          <Route path="/:lang/job-resume" component={auth(JobResume)} />
          <Route path="/:lang/crm" component={auth(Crm)} />
          <Route path="/:lang/jobsearch" component={auth(Jobsearch)} />
          <Route path="/:lang/apply-webinar" component={auth(ApplyWebinar)} />
          <Route path="/:lang/jobs" component={auth(AllJobsForUser)} />
          <Route path="/:lang/myprofile" component={auth(Myprofile)} />
          <Route path="/:lang/applied/jobs" component={auth(AppliedJobs)} />
          <Route path="/:lang/how-to-use" component={auth(HowToUse)} />
          <Route path="/:lang/job-details/:jobId" component={auth(JobDetailPage)} />
          <Route path="/:lang/interest" component={auth(Interest)} />
          <Route path="/:lang/job-mela" component={auth(jobMela)} />
          <Route path="/:lang/help-and-support" component={auth(HelpSupport)} />
          <Route path="/:lang/authentication-failure" component={auth(AuthenticationFailure)} />
          <Route path="/:lang/authentication-success" component={auth(AuthenticationSuccess)} />
          <Route path="/:lang/verify-adhar" component={auth(VerifyAdhar)} />
          <Route path="/:lang/skill-development-courses" component={auth(SkillDevelopement)} />
          <Route path="/:lang/counselling-details/:id" component={auth(CounsellingDetails)} />
          <Route path="/:lang/psdm-skill-program" component={auth(SkillProgram)} />
          <Route path="/:lang/jobfair" component={auth(checkActiveJobMela(AppliedJobFair))} />
          <Route path="/:lang/hall-ticket" component={auth(checkActiveJobMela(HallTicketList))} />
          <Route path="/:lang/hall-ticket/:id" component={auth(checkActiveJobMela(HallTicket))} />
          <Route path="/:lang/search-counselling-session" component={auth(SearchSession)} />
          <Route path="/:lang/search-career" component={auth(SearchCareer)} />
          <Route path="/:lang/search-self-employment" component={auth(SearchSelfEmployment)} />
          <Route path="/:lang/search-counselling-session-by-area" component={auth(SearchSessionByArea)} />
          <Route path="/:lang/foreign-counselling-details" component={auth(ForeignCounsellingDetails)} />
          <Route path="/:lang/hireMee" component={auth(HireMee)} />
        </Route>
      )}
      {localStorage.getItem("login_type") === "Indian Employer" && (
        <Route path="/:lang">
          <Route path="/:lang/myaccount" component={auth(JobproviderApplyJob)} />
          <Route path="/:lang/post-job" component={auth(PostJob)} />
          <Route path="/:lang/myprofile" component={auth(Providerprofile)} />
          <Route path="/:lang/verify-profile" component={auth(VerifyProfile)} />
          <Route path="/:lang/applied-candidates/:job_id" component={auth(CandidatesList)} />
          <Route path="/:lang/shortlisted-candidates/:job_id" component={auth(SelectedCandidatesList)} />
          <Route path="/:lang/selected-candidates/:job_id" component={auth(ConfirmedCandidates)} />
        </Route>
      )}
      {localStorage.getItem("login_type") === "Counselling Provider" && (
        <Route path="/:lang">
          <Route path="/:lang/myaccount" component={auth(checkCounsellor(CounsellingProviderAccount))} />
          <Route path="/:lang/myprofile" component={auth(CounsellingProviderProfile)} />
          <Route path="/:lang/post-counselling" component={auth(checkCounsellor(PostCounselling))} />
          <Route path="/:lang/session-feedback" component={auth(SessionFeedback)} />
          <Route path="/:lang/session-calendar" component={auth(SessionCalendar)} />
          <Route path="/:lang/applied-candidates/:id" component={auth(checkCounsellor(AppliedCandidates))} />
        </Route>
      )}
      <Route path="/:lang/404" component={PageNotFound} />
    </Route>

    <Redirect from="*" to="/404" />
  </Router>
);

export default router;
